import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/vehicle'));

export default function (dependencies) {
  const { language } = dependencies;

  var config = {
    label: language['vehicle-label'],
    placeholder: null,
    maxLength: 7,
    api: {
      errorMessage: language['vehicle-error'],
    },
    validators: ['mandatory'],
    behaviour: 'text-input',
  };

  const html = (props) => {
    const Lazy = withLazyComponent(Component);
    return Lazy({ ...props, ...dependencies });
  };

  return {
    html,
    config: config,
  };
}
